module.exports = __webpack_public_path__ + "static/media/YM81_4.fe26a7a7.jpg";